<template>
  <div class="login">
    <div class="content">
      <img class="bg" src="../../assets/login/login_bg.png" alt="" />
      <img class="logo" src="../../assets/login/login_logo.png" alt="" />
      <div class="title">智慧管网管理平台</div>
      <div class="loginDiv">
        <div class="hy">欢迎登录</div>
        <div class="height72" style="margin-top: 40px">
          <div class="inputTitle">账号</div>
          <el-input v-model="form.loginName" placeholder="请输入登录账号">
            <img
              slot="prefix"
              class="iconImage"
              src="../../assets/login/login_username.png"
            />
          </el-input>
        </div>
        <div class="height72" style="margin-top: 16px">
          <div class="inputTitle">密码</div>
          <el-input
            v-model="form.loginPass"
            placeholder="请输入登录密码"
            show-password
          >
            <img
              slot="prefix"
              class="iconImage"
              src="../../assets/login/login_password.png"
            />
          </el-input>
        </div>
        <!-- 租户信息 -->
        <!-- <div class="height72" style="margin-top: 16px">
          <div class="inputTitle">公司全称</div>
          <el-input v-model="form.tenantName" placeholder="请输入公司全称">
            <img
              slot="prefix"
              class="iconImage"
              src="../../assets/login/login_username.png"
            />
          </el-input>
        </div> -->
        <div class="height72" style="margin-top: 16px">
          <div class="inputTitle">验证码</div>
          <el-input
            v-model="form.code"
            placeholder="请输入验证码"
            style="width: 216px"
          >
            <img
              slot="prefix"
              class="iconImage"
              src="../../assets/login/login_code.png"
            />
          </el-input>
          <div class="vccodeStyle">
            <img :src="vcodeSrc" alt="" />
          </div>
          <el-button
            style="color: #999999; margin-left: 14px"
            type="text"
            @click="getCode"
            >换一张</el-button
          >
        </div>
        <div class="height72" style="margin-top: 24px">
          <el-button
            @click="goToLogin"
            style="
              width: 100%;
              background: linear-gradient(317deg, #028aee 0%, #0152d9 100%);
              border-radius: 2px;
              border: none;
              color: white;
              height: 46px;
              font-weight: 500;
              font-size: 16px;
            "
            >登录</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginApi from "@/api/login";
export default {
  name: "Login",
  data() {
    return {
      vcodeSrc: "",
      vcodeKey: "",
      form: {
        code: "",
        codeKey: "",
        loginName: "",
        loginPass: "",
        loginType: 0,
        tenantName: "",
        tenantId: 0,
      },
    };
  },
  mounted() {
    this.getCode();
  },
  methods: {
    getCode() {
      this.vcodeKey = Math.floor(Math.random() * 10000 + 0);
      LoginApi.getCode({ codeKey: this.vcodeKey }).then((res) => {
        let blob = new Blob([res.data], { type: "image/png" });
        this.vcodeSrc = window.URL.createObjectURL(blob);
      });
    },
    goToLogin() {
      this.form.codeKey = this.vcodeKey;
      // 获取当前 userInfo
      let userInfo = localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {};
      // 处理tenant
      if (this.form.loginName === "ys") {
        // 设置 tenantId
        // userInfo.tenantId = this.form.tenantId;
        userInfo.tenantId = 1;
        // 保存回 localStorage
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
      } else {
        userInfo.tenantId = 2;
         // 保存回 localStorage
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
      }
      // if (this.form.tenantName === "test") {
      //   this.form.tenantId = 1;
      //   const tenantInfo = { id: 1, name: "test" };
      //   localStorage.setItem("tenantInfo", JSON.stringify(tenantInfo));
      //   this.$store.dispatch("setTenantInfo", tenantInfo);
      // } else {
      //   this.form.tenantId = 2;
      //   const tenantInfo = { id: 2, name: "default" };
      //   localStorage.setItem("tenantInfo", JSON.stringify(tenantInfo));
      //   this.$store.dispatch("setTenantInfo", tenantInfo);

      // }
      // if (this.form.tenantName) {
      //   LoginApi.getTenantId({ tenantName: this.form.tenantName }).then((res) => {
      //     if (res.data.code === 200) {
      //       this.form.tenantId = res.data.data;
      //       this.login();
      //     } else {
      //       this.$message({
      //         message: res.data.message,
      //         type: "error",
      //       });
      //     }
      //   });
      // } else {
      //   this.login();
      // }

      LoginApi.loginByAccount(this.form).then((res) => {
        // console.log(res);
        if (res.data.code === 200) {
          this.$message({
            message: "登录成功",
            type: "success",
          });
          if (res.data.data.token) {
            localStorage.setItem("token", res.data.data.token.token);
            localStorage.setItem("userInfo", JSON.stringify(res.data.data));
            this.$store.dispatch("setUserInfo", res.data.data);
            localStorage.setItem("refreshToken", res.data.data.refreshToken);

            // // 保存租户信息
            // if (res.data.data.tenant) {
            //   localStorage.setItem("tenantInfo", JSON.stringify(res.data.data.tenant));
            //   this.$store.dispatch("setTenantInfo", res.data.data.tenant);
            // }

            this.$router.push("/screen"); //登录直接跳转到大屏（后期是否需根据角色不同跳转回home）
          }
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  background-color: #f4f5fa;
  min-width: 1366px;
  .content {
    width: 1366px;
    margin: auto;
    position: relative;
    .bg {
      width: 100%;
      height: auto;
    }
    .logo {
      width: 40px;
      height: 40px;
      position: absolute;
      left: 48px;
      top: 32px;
    }
    .title {
      width: 240px;
      height: 40px;
      font-weight: 600;
      font-size: 23px;
      line-height: 40px;
      color: #181818;
      position: absolute;
      left: 100px;
      top: 32px;
    }
    .loginDiv {
      position: absolute;
      right: 47px;
      top: 126px;
      width: 456px;
      height: 542px;
      background-color: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(216, 216, 216, 0.5);
      border-radius: 2px;
      .hy {
        font-weight: 500;
        font-size: 28px;
        color: #000000;
        line-height: 40px;
        width: 80%;
        height: 40;
        margin-left: 24px;
        margin-top: 40px;
      }
      .height72 {
        height: 72px;
        width: calc(100% - 48px);
        margin-left: 24px;
        .inputTitle {
          font-weight: 600;
          font-size: 14px;
          color: #181818;
          line-height: 24px;
          margin-bottom: 8px;
        }
        .iconImage {
          width: 20px;
          height: 20px;
          margin-top: 10px;
        }

        .vccodeStyle {
          width: 112px;
          height: 40px;
          display: inline-block;
          text-align: center;
          vertical-align: top;
          margin-left: 16px;
          img {
            vertical-align: bottom;
            cursor: pointer;
            width: 112px;
            height: 40px;
          }
        }
      }
    }
  }
}
</style>
